var InFlight = InFlight || {};
InFlight.Utils = (function() {
  var hash = function(str) {
    var hash = 5381,
      i = str.length;

    while (i) {
      hash = (hash * 33) ^ str.charCodeAt(--i);
    }

    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
     * integers. Since we want the results to be always positive, convert the
     * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
  };

  var hideGlobalFooter = function() {
    $('#global_footer').css('visibility', 'hidden');
  };

  var showGlobalFooter = function() {
    $('#global_footer').css('visibility', 'visible');
  };


  var _hideLoading = function(){
    setTimeout(InFlightDC.hideLoading);
  }

  var _get = function(url) {
    InFlightDC.showLoading();
    return $.get(url).then(_hideLoading, _hideLoading);
  };

  var _goTo = function(url){
    InFlightDC.showLoading();
    location.href = url;
  }

  var _isTouchDevice = function(){
    return 'ontouchstart' in window || navigator.msMaxTouchPoints;
  }

  var _getQueryStringParams = function (queryString) {
    if (queryString) {
      (/^[?#]/.test(queryString) ? query.slice(1) : queryString)
      .split('&')
      .reduce(function(params, param) {
              let [key, value] = param.split('=');
              params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
              return params;
          }, {}
      );
    }
    return {};
  };  
  
  var _toAnchor = function(url){
    //format the target as a path + query
    var a = $('<a>', {
        href: url
    })[0];
    return a;
  };

  var _isValidEmail = function(email) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }


  /**
   * Allows the user to visualize a character limit for a field.
   * @param {JQuery<HTMLElement>} $field the field that the character limit is applied to.
   * @param {number} maxCharacters the max characters allowed for this field
   * @param {JQuery<HTMLElement>} $displayCharactersElement the element to display the character counter
   */
  var _characterLimiter = function($field, maxCharacters, $displayCharactersElement) {
    $field.off().on('input', function () {
      var $this = $(this);
      var characters = $this.val() || $this.text();
      var charLength = 0;
      if (characters) {
        charLength = characters.length;
      }

      var $styledElements = $().add($this);
      if ($displayCharactersElement && $displayCharactersElement.length) {
        $displayCharactersElement.text(charLength + ' of ' + maxCharacters);
        $styledElements = $styledElements.add($displayCharactersElement);
      }
      
      if (charLength > maxCharacters) {
        $styledElements.addClass('error');
      } else {
        $styledElements.removeClass('error');
      }      
    });

    $field.trigger('input');
  }

  return {
    hash: hash,
    showGlobalFooter: showGlobalFooter,
    hideGlobalFooter: hideGlobalFooter,
    get: _get,
    goTo: _goTo,
    isTouchDevice: _isTouchDevice,
    toAnchor: _toAnchor,
    getQueryStringParams: _getQueryStringParams,
    isValidEmail: _isValidEmail,
    characterLimiter: _characterLimiter
  };
})();
